import router from './router'

// fix the tooltip cant be removed when navigating to another page
router.beforeEach((from, to, next) => {
    const allTooltips = document.querySelectorAll('.el-tooltip__popper')
    if (allTooltips.length) {
        Array.from(allTooltips).map(node => document.body.removeChild(node))
    }
    next()
})
